<template>
  <WdsText class="tw-truncate" :text="date" />
</template>

<script lang="ts" setup>
import { WdsText } from '@worksome/wds-components'
import { graphql } from '@/gql'
import { JobCreatedAtColumnFragment } from '@/gql/graphql'
import useDate from '@/composables/useDate'

graphql(`
  fragment JobCreatedAtColumn on Job {
    id
    createdAt
  }
`)

const props = defineProps<{ row: JobCreatedAtColumnFragment }>()
const { date } = useDate(props.row.createdAt)
</script>
